import React from "react";

const LoadingSkeleton: React.FC = () => {
  return (
    <div className="scheduler-loading-skeleton animate-pulse">
      {/* Header Skeleton */}
      <div className="mb-6">
        <div className="flex items-center justify-between">
          <div className="h-8 bg-gray-200 dark:bg-gray-700 rounded w-48"></div>
          <div className="flex gap-2">
            <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-32"></div>
            <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-40"></div>
          </div>
        </div>
      </div>

      {/* Calendar Skeleton */}
      <div className="bg-white dark:bg-zinc-900 border border-zinc-200 dark:border-zinc-700 rounded-lg shadow-sm overflow-hidden">
        {/* Toolbar Skeleton */}
        <div className="p-4 border-b border-zinc-200 dark:border-zinc-700 bg-zinc-50 dark:bg-zinc-800">
          <div className="text-center mb-4">
            <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded w-32 mx-auto"></div>
          </div>
          <div className="flex flex-wrap items-center justify-between gap-4">
            <div className="flex items-center gap-2">
              <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-8"></div>
              <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-24"></div>
            </div>
            <div className="flex items-center gap-2">
              <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-10"></div>
              <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-16"></div>
              <div className="h-10 bg-gray-200 dark:bg-gray-700 rounded w-10"></div>
            </div>
          </div>
        </div>

        {/* Calendar Grid Skeleton */}
        <div className="p-4">
          <div className="grid grid-cols-7 gap-1 mb-2">
            {Array.from({ length: 7 }).map((_, i) => (
              <div key={i} className="h-8 bg-gray-200 dark:bg-gray-700 rounded"></div>
            ))}
          </div>
          <div className="grid grid-cols-7 gap-1">
            {Array.from({ length: 35 }).map((_, i) => (
              <div key={i} className="h-20 bg-gray-100 dark:bg-gray-800 rounded relative">
                <div className="absolute top-1 left-1 h-4 bg-gray-200 dark:bg-gray-700 rounded w-6"></div>
                {/* Event skeletons */}
                {i % 5 === 0 && (
                  <div className="absolute top-6 left-1 right-1 h-3 bg-blue-200 dark:bg-blue-800 rounded"></div>
                )}
                {i % 7 === 0 && (
                  <div className="absolute top-10 left-1 right-1 h-3 bg-green-200 dark:bg-green-800 rounded"></div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoadingSkeleton; 